import { observer } from "mobx-react";
import { Modal } from "antd";
import { translateKey as t } from "../../../../../../locales/translation";
import { ClientsController } from "../../../ClientsController";
import { AppStore } from "~/stores/AppStore";
import { useEffect } from "react";
import ImportModalContent from "./ImportModalContent";

const DataImporterModal = observer(({ store, controller }: { store?: AppStore; controller?: ClientsController }) => {
  useEffect(() => {});

  const handleOK = () => {
    controller.importData();
  };

  const handleCancel = () => {
    controller.setDataImporterModal(null, {
      visible: false,
      loading: false,
      row: null,
      uploadLoading: false,
      importedData: [],
      file: null,
      postDataErrors: [],
    });
    // controller.resetDataImporterFields();
  };

  if (!controller.dataImporterModal.visible) {
    return null;
  }

  console.log("loading ", controller.dataImporterModal.loading);
  return (
    <Modal
      title={"Data Importer: " + controller?.dataImporterModal?.row?.name}
      open={controller.dataImporterModal.visible}
      cancelText={t("lblCancel", "Cancel")}
      okText={t("lblImport", "Import")}
      okButtonProps={{ disabled: controller.dataImporterModal.importedData.length === 0 || controller.dataImporterModal.preDataErrors.length > 0 }}
      onCancel={handleCancel}
      centered={true}
      okType="primary"
      onOk={handleOK}
      maskClosable={false}
      cancelButtonProps={{ disabled: controller.dataImporterModal.loading }}
      confirmLoading={controller.dataImporterModal.loading}
    >
      <ImportModalContent controller={controller} store={store} />
    </Modal>
  );
});

export default DataImporterModal;
